import appClient from "@/services/app/app.client";
import { APP_ENDPOINTS } from "@/services/app/app.constants";
import { TLocaleRequest } from "@/services/app/app.types";
import { createPayload } from "@/services/app/app.utils";

import {
  TCreateBillingRequest, TCreateBillingResponse, TGetInstallationListResponse, TOnboardingDataResponse,
} from "./MultiStepForm.types";

export const createBilling = (payload: TCreateBillingRequest) => {
  return appClient.post<TCreateBillingRequest, TCreateBillingResponse>(
    APP_ENDPOINTS.BILLING.CREATE_CONTEXT_WITH_CONTRACT,
    createPayload(payload),
  );
};

export const getBillingOnboardingData = () => {
  return appClient.post<TLocaleRequest, TOnboardingDataResponse>(
    APP_ENDPOINTS.BILLING.GET_ONBOARDING_DATA,
    createPayload("", {
      locale: true,
    }),
  );
};

export const getInstallationList = () => {
  return appClient.post<TLocaleRequest, TGetInstallationListResponse>(
    APP_ENDPOINTS.BILLING.GET_INSTALLATION_LIST,
    createPayload("", {
      locale: true,
    }),
  );
};
